import preval from 'preval.macro';

module.exports = require(preval`module.exports = process.env.REF_RECORDS_CONSTANTS_PATH`)